import { RoundButton } from '@components/Button/RoundButton/RoundButton';
import { buttonClasses, styled } from '@mui/material';

export const SquareButton = styled(RoundButton)`
    border-radius: ${({ theme }) => theme.shape.borderRadiusLarge}px;
    font-family: Roboto, serif;
    font-weight: 500;
    text-transform: uppercase;
    padding-left: 10px;
    padding-right: 10px;
    &.${buttonClasses.sizeSmall} {
        color: ${({ theme }) => theme.palette.blue.lightest};
        font-size: ${({ theme }) => theme.typography.fontSize}px;
    }
    .disabled {
        cursor: default;
    }
`;
